import { useTranslation } from 'react-i18next'
// material
import { enUS, myMY, thTH } from '@mui/material/locale'

// ----------------------------------------------------------------------

const LANGS = [
  {
    label: 'ไทย',
    value: 'th',
    systemValue: thTH,
    icon: '/static/icons/lang/thailand.svg',
  },
  {
    label: 'မြန်မာ',
    value: 'my',
    systemValue: myMY,

    icon: '/static/icons/lang/myanmar.svg',
  },
  {
    label: 'English',
    value: 'en',
    systemValue: enUS,
    icon: '/static/icons/lang/uk.svg',
  },
]

export default function useLocales() {
  const { i18n, t: translate } = useTranslation()
  const langStorage = localStorage.getItem('i18nextLng')
  const currentLang = LANGS.find((_lang) => _lang.value === langStorage) || LANGS[0]

  const handleChangeLanguage = (newlang: string) => {
    i18n.changeLanguage(newlang)
  }

  return {
    onChangeLang: handleChangeLanguage,
    translate,
    currentLang,
    allLang: LANGS,
  }
}
